import React, { useEffect, useState } from "react";
import Tabla from "./Tabla/index";
import TablaArchivo from "./TablaInactivos";
import concesionaria_icon from "../../../assets/vw/svg/concesionarias.svg";
import ARCH from "../../../assets/vw/svg/archivo.svg";
import Loading from "../../../components/Loading";
import Menu from "../../../components/Menu";
import Modal from "../../../components/Modal";
import NoInfoScreen from "../../../components/Screens/NoInfoScreen";

/** @typedef {import("react-router-dom").RouteComponentProps} RouteComponentProps */

/**
 * @param {RouteComponentProps} props
 * @returns {JSX.Element}
 */
export default function Concesionarias(props) {
  const url = process.env.REACT_APP_URL_DTO_BACK + "concesionaria";

  const [fetchedConcesionarias, setFetchedConcesionarias] = useState([]);
  const [filteredConcesionarias, setFilteredConcesionarias] = useState([]);
  const [filteredConcesionariasInactivas, setFilteredConcesionariasInactivas] = useState([]);
  const [option, setOption] = useState("concesionarias");
  const [concesionariasInactivas, setConcesionariasInactivas] = useState([]);
  const [dataOriginal, setDataOriginal] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [modal, setModal] = useState({
    active: false,
    message: '',
    success: false
  }); 

  async function getConcesionarias() {
    try {
      setCargando(true);
      setModal({
        active: false,
        message: '',
        success: false
      });

      const response = await fetch(`${url}?numCON=todos`, {
        method: "GET",
        headers: {
          Authorization: "Bearer " + props.servicio.getToken(),
          "Content-Type": "application/json",
        },
      });
      setCargando(false);
      const data = await response.json();

      if (!response.ok) {
        throw new Error(
          "Error en el feching de CONCESIONARIAS" + data.mensaje
        );
      }
      
      

      const activas = data.mensaje.filter((concesionaria) => {//data.mensaje.filter
        return concesionaria.estadoActivo === 1;
      });
      setFetchedConcesionarias(activas);
      setDataOriginal(data.mensaje);//data.mensaje
    } catch (error) {
      setCargando(false);
      setModal({
        active: true,
        message: error.message,
        success: false
      });
    }
  }

  //Obtiene lo tecleado en el buscador
  const handleChange = (e) => {
    if (option === "archivo") {
      filtrarInactivas(e.target.value)
    } else
    {filtrar(e.target.value);}
  };

  //almacena los datos que hacen MATCH de lo tecleado en el buscador
  const filtrar = (terminoBusqueda) => {
    if (terminoBusqueda === "") {
      setFilteredConcesionarias([]);
      return;
    }
    const resultado = fetchedConcesionarias.filter((concesionaria) => {
      return (
        concesionaria.numCON
          .toLowerCase()
          .includes(terminoBusqueda.toLowerCase()) 
      );
    });

    setFilteredConcesionarias(resultado); //Obtenemos los match
  };

  const filtrarInactivas = (terminoBusqueda) => {
    if (terminoBusqueda === "") {
      setFilteredConcesionariasInactivas([]);
      return;
    }
    const resultado = concesionariasInactivas.filter((concesionaria) => {
      return (
        concesionaria.numCON
          .toLowerCase()
          .includes(terminoBusqueda.toLowerCase()) ||
        concesionaria.razon
          .toLowerCase()
          .includes(terminoBusqueda.toLowerCase()) ||
        concesionaria.idCON
          .toString()
          .toLowerCase()
          .includes(terminoBusqueda.toLowerCase())
      );
    });

    setFilteredConcesionariasInactivas(resultado); //Obtenemos los match
  };

  useEffect(() => {
    getConcesionarias();
  }, []);

  const changeOption = (option) => {
    setOption(option);
    setFilteredConcesionarias([])
    setFilteredConcesionariasInactivas([])
    if (option === "archivo") {
      getConcensionariasInactivas(dataOriginal);
    }
  };

  const getConcensionariasInactivas = (data) => {
    const inactivas = data.filter((concesionaria) => {
      return concesionaria.estadoActivo === 0;
    });
    setConcesionariasInactivas(inactivas);
  };


  return (
    <>
    <Menu/>
    <Modal modalInfo={modal} setMostrarModal={setModal} />
    {
      cargando && <Loading />
    }
      <div className={`navegacion`}>
        {fetchedConcesionarias?.length > 0 ? (
          <>
            <div className=" posicionMenu">
              <ul className="d-flex flex-row px-0 my-0">
                <li
                  className="opcion-ruta"
                  onClick={() => changeOption("concesionarias")}
                >
                  <div
                    className={`nav-link nav-link-title active ps-0 ${
                      option === "concesionarias" ? " active border_menu" : ""
                    }`}
                  >
                    <img
                      src={concesionaria_icon}
                      alt="concesionaria"
                      className="icono-menu me-3"
                    />
                    Concesionarias
                  </div>
                </li>
                <li
                  className="opcion-ruta"
                  onClick={() => changeOption("archivo")}
                >
                  <div
                    className={`nav-link active ps-0  ${
                      option === "archivo" ? " active border_menu" : ""
                    }`}
                  >
                    <img src={ARCH} alt="archivo" className="icono-menu me-3" />
                    Archivo
                  </div>
                </li>
              </ul>
            </div>
            <div className="row  border_vw pt-4 ms-0 mx-0">
              <div className="col-12 p-0 contenedor-table">
                {option === "archivo" ? (
                  <TablaArchivo
                    data={
                      filteredConcesionariasInactivas &&
                      filteredConcesionariasInactivas.length > 0
                        ? filteredConcesionariasInactivas
                        : concesionariasInactivas
                    }
                    servicio={props.servicio}
                    handleChange={handleChange}
                  />
                ) : (
                  <Tabla
                    data={
                      filteredConcesionarias &&
                      filteredConcesionarias.length > 0
                        ? filteredConcesionarias
                        : fetchedConcesionarias
                    }
                    servicio={props.servicio}
                    handleChange={handleChange}
                  />
                )}
              </div>
            </div>
          </>
        ) : (
          <>
            {
              !cargando && <NoInfoScreen />
            }
          </>
        )
        
        }
      </div>
    </>
  );
}
